import fetch from '@/utils/fetch';

const model = {
  state: {},
  reducers: (state: any, partialState: any) => {
    return { ...state, ...partialState };
  },
  actions: () => ({
    async getSalarySettingConfig() {
      return fetch('/saasmerchant/web/settlement/salary/cycleconfig');
    },
  }),
};

export default model;
